import { useTranslation } from "@equiem/web-ng-lib";
import { PageTitle } from "@equiem/web-ng-lib";
import { NextPage } from "next";
import React from "react";
import { GeneralLayout } from "../components/layout/GeneralLayout";
import { LegalContent } from "../components/legal/LegalContent";
import { withAppContexts } from "../contexts/withAppContexts";
import { PageViewPageType } from "../generated/gateway-client";

export const CookiePage: NextPage = ({}) => {
  const { t } = useTranslation();

  return (
    <GeneralLayout>
      <h1 className="text-site">{t("main.cookiesPolicy")}</h1>
      <PageTitle>{t("main.cookiesPolicy")}</PageTitle>
      <LegalContent type="cookies" />
    </GeneralLayout>
  );
};

export default withAppContexts(CookiePage, {
  requireAuth: false,
  skipCookieConsent: true,
  skipMetrics: false,
  pageViewType: PageViewPageType.Static,
  pageTitle: "Cookies Policy",
});
